// extracted by mini-css-extract-plugin
export var panel = "PasswordProtection-module--panel--c5a4a";
export var title = "PasswordProtection-module--title--ffe09";
export var wrapper = "PasswordProtection-module--wrapper--ef9b3";